import { useEffect } from "react"

/**
 *
 * @param {function[]} callback
 * @param {string} articleId - The ID of the article to track
 * @returns Current progress in percentage
 *
 */

const useProgress = (callback, articleId) => {
  const handleScroll = (event) => {
    if (!callback) {
      throw new Error(
        "No callback provided! Calling this function without a callback is redundant.",
      )
    }

    const doc = event.target.documentElement
    const currentScrollTop = doc.scrollTop
    const windowHeight = doc.clientHeight
    const navigationHeight = document.querySelector("#article-navigation")?.offsetHeight || 0
    const astrologyLinksHeight = document.querySelector("#astro-header")?.offsetHeight || 0

    // Get the specific article container using articleId
    const articleContainer = document.querySelector(`#article-container-${articleId}`)
    if (!articleContainer) return

    const articleHeight = articleContainer.getBoundingClientRect().height
    const articleTop = articleContainer.getBoundingClientRect().top + window.scrollY

    // Calculate the scrollable area for this article
    const scrollableHeight = articleHeight - windowHeight
    if (scrollableHeight <= 0) return

    // Calculate how far we've scrolled within this article
    const scrolledInArticle = Math.max(
      0,
      currentScrollTop - articleTop + navigationHeight + astrologyLinksHeight,
    )

    // Calculate progress as a percentage
    const currentProgress = Math.floor(
      Math.max(Math.min((scrolledInArticle / scrollableHeight) * 100, 100), 0),
    )

    callback(currentProgress)
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true })
    return () => window.removeEventListener("scroll", handleScroll)
  }, [articleId])
}

export default useProgress
